import React from "react";
import { Search } from "lucide-react";

const SearchBar = ({ onSearch }) => {
  return (
    <div className="w-full max-w-[calc(100%-90px)] relative mx-auto">
      <input
        type="text"
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Recherchez"
        className="border border-Stone-400 rounded-lg px-4 py-2 w-full pr-10"
      />
      <Search className="absolute right-3 top-2.5 text-gray-500 w-5 h-5" />
    </div>
  );
};

export default SearchBar;
